import React, { useState, useCallback } from "react";
import {
  BiRightArrowAlt,
  BiSolidArrowToRight,
  BiSolidXCircle,
  BiXCircle,
} from "react-icons/bi";
import { BsArrow90DegRight, BsArrowRight } from "react-icons/bs";
import ReactTooltip from "react-tooltip";
import { applyCustomFontStyles, renderCommentsCountTextFormat, THEME_SETTING } from "../data";
import debounce from "lodash.debounce";
import QuizTextEditor from "../../../components/QuizTextEditor/QuizTextEditor";
import StarRatings from "react-star-ratings";
import { Button } from "reactstrap";
import Toggle from "react-toggle";
import TriviaCommentsComponent from "./TriviaCommentsComponent";
import { LuMessageSquare } from "react-icons/lu";

export default function TriviaEndingComponent({
  endingData,
  editEndingData,
  view,
  themeSettings,
  callApiToAutoSave,
  isEditable,
  showRatingUI,
  editRatingData,
  ratingData,
  triviaId,
  endingComments,
  updateTriviaComments,
}) {
  const isMobile = view === "MOBILE";
  const [commentsPopoverOpen, setCommentsPopoverOpen] = useState(false);

  const applyCustomThemeSettings = () => {
    if (
      themeSettings &&
      (themeSettings.quizBackgroundColor || themeSettings.quizTextColor)
    ) {
      return true;
    }
    return false;
  };

  const [starRating, setStarRating] = useState(0);

  const editQuestionText = (key, value) => {
    const data = {
      ...endingData,
    };

    data[key] = value;

    editEndingData(data);
    debounceAutoSaveData("endingPage", data);
  };

  const debounceAutoSaveData = useCallback(
    debounce(callApiToAutoSave, 3000),
    []
  );

  const setComments = comments => {
    const data = {
      ...endingData,
      commentsCount: comments.length,
    };

    updateTriviaComments("ENDING", comments);

    editEndingData(data);
    callApiToAutoSave("endingPage", data);
  };
  return (
    <div
      className={
        isMobile
          ? `trivia-survey-edit-questions-ui-mobile py-1 px-3 ${
              applyCustomThemeSettings() && themeSettings.quizBackgroundColor
                ? ""
                : "endUi trivia-end-block-css"
            }`
          : `trivia-survey-edit-questions-ui py-1 ${
              applyCustomThemeSettings() && themeSettings.quizBackgroundColor
                ? ""
                : "endUi trivia-end-block-css"
            }`
      }
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...(applyCustomThemeSettings()
          ? {
              ...(themeSettings.quizBackgroundColor && {
                backgroundColor: themeSettings.quizBackgroundColor,
              }),

              ...(themeSettings.quizTextColor
                ? { color: themeSettings.quizTextColor }
                : { color: "white" }),
            }
          : {
              color: "white",
            }),
      }}
    >
    <div style={applyCustomFontStyles(themeSettings)}>
      <div
        className={
          !isMobile
            ? "trivia-survey-edit-questions-ui_centerUI mt-4 pl-0"
            : "trivia-survey-edit-questions-ui_centerUI_mobile mt-2"
        }
        style={{ width: "100%" }}
      >
        <div style={{ flex: 1 }}>
          <div
            className="trivia-survey-edit-questions-ui_question_title"
            style={{ justifyContent: "center" }}
          >
            <QuizTextEditor
              blockId={2}
              value={endingData.heading}
              onChange={e => {
                editQuestionText("heading", e);
              }}
              placeholder="Your welcome title here..."
              style={{
                width: "100%",
                fontSize: "37px",
              }}
              disabled={!isEditable}
              questionThemeSettings={themeSettings}
            />
          </div>

          {/* <div
            className="trivia-survey-edit-questions-ui_question_title mt-3"
            style={{ justifyContent: "center" }}
          >
            <QuizTextEditor
              blockId={1}
              value={endingData.subHeading}
              onChange={e => {
                editQuestionText("subHeading", e);
              }}
              placeholder="Description here ..."
              style={{
                width: "100%",
                fontSize: "25px",
              }}
              disabled={!isEditable}
              questionThemeSettings={themeSettings}
            />
          </div> */}
        </div>
      </div>
      </div>
    

      <div className="d-block trivvy-comments-w-container">
        <div
          className="cursor-pointer d-flex align-items-center"
          style={{
            float: "right",
          }}
          onClick={() => setCommentsPopoverOpen(!commentsPopoverOpen)}
        >
          <span
            className="font-styling-right-sidebar-items mr-2"
            id={`comments-popover-x`}
          >
            {" "}
            Comments (
            {renderCommentsCountTextFormat(endingData.commentsCount) || 0})
          </span>
          <LuMessageSquare size={16} />
        </div>

        {commentsPopoverOpen && (
          <TriviaCommentsComponent
            commentsPopoverOpen={commentsPopoverOpen}
            setCommentsPopoverOpen={setCommentsPopoverOpen}
            target={`comments-popover-x`}
            comments={endingComments}
            setComments={setComments}
            questionId={"ENDING"}
            triviaId={triviaId}
          />
        )}
      </div>
    </div>
  );
}
